import { IRequest } from '@r1-frontend/shared/types/IRequest';

type TQueryParams = {
    address: string,
    salePackageId?: number,
    withReissue?: boolean,
};

/**
 * Address checking for availability of connection
 * @param address
 * @param salePackageId
 * {@link https://master.dadata-proxy.sandbox.d2c.r-one.io/docs#/Check%20address/CheckAddressController_checkAddressAction}
 */
const check = (params: TQueryParams): IRequest => {
    const { address, salePackageId, withReissue = false } = params;

    const queryParams: Record<string, unknown> = {
        address,
    };

    if (salePackageId) {
        queryParams['salePackageId'] = salePackageId;
    }

    if (withReissue) {
        queryParams['withReissue'] = 1;
    }

    return {
        uri: '/v1/address/check',
        method: 'GET',
        queryParams,
        withProvider: true,
        withAuth: withReissue,
    };
};

export default check;
